import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconArrowExport: React.FC<Props> = ({
  width = 16,
  height = 16,
  color = '#00795B',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.8334 2.66602V5.99935C13.8334 6.27535 13.6094 6.49935 13.3334 6.49935C13.0574 6.49935 12.8334 6.27535 12.8334 5.99935V3.87337L7.68671 9.02002C7.58937 9.11735 7.46135 9.16667 7.33335 9.16667C7.20535 9.16667 7.07733 9.11802 6.98 9.02002C6.78467 8.82469 6.78467 8.508 6.98 8.31266L12.1266 3.16602H10C9.72402 3.16602 9.50002 2.94202 9.50002 2.66602C9.50002 2.39002 9.72402 2.16602 10 2.16602H13.3334C13.3987 2.16602 13.4634 2.17942 13.5248 2.20475C13.6468 2.25542 13.7441 2.35276 13.7954 2.47542C13.8201 2.53609 13.8334 2.60068 13.8334 2.66602ZM13.3334 8.16602C13.0574 8.16602 12.8334 8.39002 12.8334 8.66602V11.3327C12.8334 12.384 12.3847 12.8327 11.3334 12.8327H4.66669C3.61535 12.8327 3.16669 12.384 3.16669 11.3327V4.66602C3.16669 3.61468 3.61535 3.16602 4.66669 3.16602H7.33335C7.60935 3.16602 7.83335 2.94202 7.83335 2.66602C7.83335 2.39002 7.60935 2.16602 7.33335 2.16602H4.66669C3.05469 2.16602 2.16669 3.05402 2.16669 4.66602V11.3327C2.16669 12.9447 3.05469 13.8327 4.66669 13.8327H11.3334C12.9454 13.8327 13.8334 12.9447 13.8334 11.3327V8.66602C13.8334 8.39002 13.6094 8.16602 13.3334 8.16602Z"
      fill={color}
    />
  </svg>
);

export default IconArrowExport;
